import http from '../utils/http-common'
const getAll = () => {
  return http.get('/shipping-methods')
}

const ShippingMethodsDataService = {
  getAll,
}
export default ShippingMethodsDataService
